import React from 'react';
import { keyframes } from '@emotion/react';
import { Button, IconButton, Tooltip, alpha, useMediaQuery, useTheme } from '@mui/material';
import { HelpOutline } from '@mui/icons-material';

const BLINK_EVERY_SECONDS = 10;

// Two quick glow pulses at the start of each cycle (~1s), then rest until the next cycle.
const blink = (color) => keyframes`
  0%, 8%, 100% { box-shadow: 0 0 0 0 ${alpha(color, 0)}; background-color: transparent; }
  2%, 6% { box-shadow: 0 0 0 6px ${alpha(color, 0.25)}; background-color: ${alpha(color, 0.12)}; border-color: ${color}; }
  4% { box-shadow: 0 0 0 2px ${alpha(color, 0.1)}; background-color: transparent; }
`;

// "Guide" button for page headers; replays the module's guided tour.
// It blinks every 15 seconds to remind users the guide is there.
const TourButton = ({ onClick, sx }) => {
  const theme = useTheme();
  const compact = useMediaQuery(theme.breakpoints.down('sm'));

  const blinkSx = {
    animation: `${blink(theme.palette.primary.main)} ${BLINK_EVERY_SECONDS}s ease-in-out 3s infinite`,
    '&:hover, &:focus-visible': { animation: 'none' },
    '@media (prefers-reduced-motion: reduce)': { animation: 'none' },
  };

  if (compact) {
    return (
      <Tooltip title="Show guide">
        <IconButton onClick={onClick} aria-label="Show guide" sx={{ border: 1, borderColor: 'divider', ...blinkSx, ...sx }}>
          <HelpOutline fontSize="small" />
        </IconButton>
      </Tooltip>
    );
  }

  return (
    <Button variant="outlined" startIcon={<HelpOutline />} onClick={onClick} sx={{ ...blinkSx, ...sx }}>
      Guide
    </Button>
  );
};

export default TourButton;
